import { getContract, useAddress } from '@thirdweb-dev/react';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { useConfig } from '@app/config';
import { Mode } from '@thirdweb-dev/chains';

import nftMarketplaceAbi from 'abis/NFTMarketPlace.json';
import { formatUnits } from 'ethers/lib/utils';
import { ModeChain } from '@app/constants/chains';

async function fetcher(
  address: string | undefined,
  nftMarketplaceContractAddress: string | undefined
) {
  if (!nftMarketplaceContractAddress || !address) {
    return null;
  }

  const contract = await getContract({
    address: nftMarketplaceContractAddress,
    network: ModeChain,
    contractTypeOrAbi: nftMarketplaceAbi
  });

  // @ts-ignore
  const res = await contract.call('totalUserXKimAllocationToPlugin', [address]);

  return formatUnits(res, 18);
}

export function useUserXKimAllocationToPlugin() {
  const address = useAddress();
  const config = useConfig();

  return useQuery(
    [
      QueryKeys.GET_USER_X_KIM_ALLOCATION_TU_PLUGIN,
      address,
      config?.CONTRACTS.NFT_MARKETPLACE
    ],
    () => fetcher(address, config?.CONTRACTS.NFT_MARKETPLACE),
    {
      enabled: !!(address && config?.CONTRACTS.NFT_MARKETPLACE),
      staleTime: 5000
    }
  );
}
